<template>
  <div>
    <SettingsHelperComponents1MainPage />
  </div>
</template>

<script>

import Vue from 'vue'
import Component from 'vue-class-component'

import SettingsHelperComponents1MainPage from './service-for-settings-helper-components/settings-helper-components-1-main-page.vue'

@Component({
  components: {
    SettingsHelperComponents1MainPage
  }
})
class Settings1 extends Vue {
  //
}

export default Settings1


</script>

<style>

</style>